import ReportIcon from '@material-ui/icons/FormatListNumbered';
import ReportList from './ReportList';

export default {
    list: ReportList,
    icon: ReportIcon,
};
